import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '../../assets/images/Monteria11.jpg'


const _hoisted_1 = { class: "max-w-full mx-auto px-4 sm:px-6 flex justify-content-between items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "2xl:container 2xl:mx-auto lg:pl-15 lg:pr-0 md:px-6 py-9 px-4 w-1/2 hidden sm:block" }, [
  /*#__PURE__*/_createElementVNode("a", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      class: "h-auto w-auto p-10 mb-20 pb-5 lg:pr-1.5",
      alt: ""
    })
  ])
], -1)
const _hoisted_3 = { class: "2xl:container 2xl:mx-auto md:py-20 lg:pr-15 lg:pl-0 md:px-6 py-9 px-4 w-1/2" }
const _hoisted_4 = { class: "max w-full mx-auto px-4 sm:px-6 sm:pr-20 lg:pl-2" }
const _hoisted_5 = { class: "w-full flex flex-col justify-content-center items-center w-[300px] sm:w-full" }
const _hoisted_6 = { class: "font-semibold lg:text-4xl text-3xl lg:leading-9 md:leading-7 leading-9 text-curaduria" }
const _hoisted_7 = { class: "lg:text-lg text-lg text-justify lg:leading-9 md:leading-7 leading-9 text-black mt-2 font-normal" }
const _hoisted_8 = { class: "rounded-md px-4 py-5 sm:px-6 mt-2 bg-white w-[300px] sm:w-full" }
const _hoisted_9 = { class: "grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2" }
const _hoisted_10 = { class: "sm:col-span-1" }
const _hoisted_11 = { class: "text-sm font-medium text-curaduria" }
const _hoisted_12 = { class: "mt-1 text-sm text-gray-900" }
const _hoisted_13 = { class: "sm:col-span-1" }
const _hoisted_14 = { class: "text-sm font-medium text-curaduria" }
const _hoisted_15 = { class: "mt-1 text-sm text-gray-900" }
const _hoisted_16 = { class: "sm:col-span-1" }
const _hoisted_17 = { class: "text-sm font-medium text-curaduria" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("dd", { class: "mt-1 text-sm text-gray-900" }, "info@curaduria2monteria.com", -1)
const _hoisted_19 = { class: "sm:col-span-1" }
const _hoisted_20 = { class: "text-sm font-medium text-curaduria" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("dd", { class: "mt-1 text-sm text-gray-900" }, "info@curaduria2monteria.com", -1)
const _hoisted_22 = { class: "sm:col-span-1" }
const _hoisted_23 = { class: "text-sm font-medium text-curaduria" }
const _hoisted_24 = { class: "mt-1 text-sm text-gray-900" }
const _hoisted_25 = { class: "sm:col-span-1" }
const _hoisted_26 = { class: "text-sm font-medium text-curaduria" }
const _hoisted_27 = { class: "mt-1 text-sm text-gray-900" }
const _hoisted_28 = { class: "sm:col-span-2" }
const _hoisted_29 = { class: "" }
const _hoisted_30 = { class: "text-lg leading-6 font-medium text-curaduriaDark" }
const _hoisted_31 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_32 = { class: "mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6" }
const _hoisted_33 = { class: "sm:col-span-3" }
const _hoisted_34 = {
  for: "first-name",
  class: "block text-sm font-medium text-curaduria"
}
const _hoisted_35 = { class: "mt-1" }
const _hoisted_36 = { class: "sm:col-span-3" }
const _hoisted_37 = {
  for: "last-name",
  class: "block text-sm font-medium text-curaduria"
}
const _hoisted_38 = { class: "mt-1" }
const _hoisted_39 = { class: "sm:col-span-6" }
const _hoisted_40 = {
  for: "email",
  class: "block text-sm font-medium text-curaduria"
}
const _hoisted_41 = { class: "mt-1" }
const _hoisted_42 = { class: "sm:col-span-6" }
const _hoisted_43 = {
  for: "message",
  class: "block text-sm font-medium text-curaduria"
}
const _hoisted_44 = { class: "mt-1" }
const _hoisted_45 = {
  key: 0,
  class: "sm:col-span-6"
}
const _hoisted_46 = { class: "sm:col-span-6" }
const _hoisted_47 = { class: "py-2 relative flex text-sm justify-center text-gray-500" }
const _hoisted_48 = {
  class: "underline underline-offset-2",
  href: "https://policies.google.com/privacy"
}
const _hoisted_49 = {
  class: "underline underline-offset-2",
  href: "https://policies.google.com/terms"
}

export function render(_ctx, _cache) {
  const _component_Header = _resolveComponent("Header")
  const _component_Alert = _resolveComponent("Alert")
  const _component_Footer = _resolveComponent("Footer")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t("contact.title")), 1),
            _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.$t("contact.des")), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("dl", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("dt", _hoisted_11, _toDisplayString(_ctx.$t("contact.addressLabel")), 1),
                _createElementVNode("dd", _hoisted_12, _toDisplayString(_ctx.$t("contact.address")), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("dt", _hoisted_14, _toDisplayString(_ctx.$t("contact.schedule")), 1),
                _createElementVNode("dd", _hoisted_15, _toDisplayString(_ctx.$t("contact.scheduleHor")), 1)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("dt", _hoisted_17, _toDisplayString(_ctx.$t("contact.emailLabel")), 1),
                _hoisted_18
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("dt", _hoisted_20, _toDisplayString(_ctx.$t("contact.emailNotLabel")), 1),
                _hoisted_21
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("dt", _hoisted_23, _toDisplayString(_ctx.$t("contact.telephoneLabel")), 1),
                _createElementVNode("dd", _hoisted_24, _toDisplayString(_ctx.$t("contact.telephone")), 1)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("dt", _hoisted_26, _toDisplayString(_ctx.$t("contact.cellphoneLabel")), 1),
                _createElementVNode("dd", _hoisted_27, _toDisplayString(_ctx.$t("contact.cellphone")), 1)
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_30, _toDisplayString(_ctx.$t("contact.formTitle")), 1),
                    _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.$t("contact.formDescription")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.$t("contact.nameLabel")), 1),
                      _createElementVNode("div", _hoisted_35, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.name) = $event)),
                          name: "first-name",
                          id: "first-name",
                          autocomplete: "given-name",
                          class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                        }, null, 512), [
                          [_vModelText, _ctx.name]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t("contact.lastNameLabel")), 1),
                      _createElementVNode("div", _hoisted_38, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.lastName) = $event)),
                          name: "last-name",
                          id: "last-name",
                          autocomplete: "family-name",
                          class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                        }, null, 512), [
                          [_vModelText, _ctx.lastName]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.$t("contact.emailLabel")), 1),
                      _createElementVNode("div", _hoisted_41, [
                        _withDirectives(_createElementVNode("input", {
                          id: "email",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.email) = $event)),
                          name: "email",
                          type: "email",
                          autocomplete: "email",
                          placeholder: "you@email.com",
                          class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                        }, null, 512), [
                          [_vModelText, _ctx.email]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.$t("contact.messageLabel")), 1),
                      _createElementVNode("div", _hoisted_44, [
                        _withDirectives(_createElementVNode("textarea", {
                          type: "text",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.message) = $event)),
                          name: "message",
                          id: "message",
                          class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                        }, null, 512), [
                          [_vModelText, _ctx.message]
                        ])
                      ])
                    ]),
                    (_ctx.informativeMessage)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                          _createVNode(_component_Alert, {
                            type: 'error',
                            message: _ctx.informativeMessage
                          }, null, 8, ["message"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("button", {
                        type: "submit",
                        onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.validateDataBeforeSend && _ctx.validateDataBeforeSend(...args))),
                        class: "inline-flex w-full justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-curaduria hover:bg-curaduriaDark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-curaduria"
                      }, _toDisplayString(_ctx.$t("contact.sendBtnText")), 1),
                      _createElementVNode("p", _hoisted_47, [
                        _createElementVNode("span", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t("contact.googleDisclaimer")) + " ", 1),
                          _createElementVNode("a", _hoisted_48, _toDisplayString(_ctx.$t("contact.googlePrivacy")), 1),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("contact.and")) + " ", 1),
                          _createElementVNode("a", _hoisted_49, _toDisplayString(_ctx.$t("contact.googleTerms")), 1),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("contact.apply")) + ".", 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Footer)
  ], 64))
}